import { render, staticRenderFns } from "./CreateLotsDialog.vue?vue&type=template&id=1fe21cfc"
import script from "./CreateLotsDialog.vue?vue&type=script&lang=js"
export * from "./CreateLotsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports